interface NewBadgeProps {
  /** `pill` writes « Nouveau » ; `dot` is a small marker for crowded places (table rows). */
  variant?: 'pill' | 'dot';
  className?: string;
}

/** Marks a recently shipped feature where it lives. Shown or not by `useNewFeature`. */
export function NewBadge({ variant = 'pill', className = '' }: NewBadgeProps) {
  if (variant === 'dot') {
    return (
      <span
        className={`absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-primary-500 ring-2 ring-white ${className}`}
        aria-label="Nouveau"
        role="img"
      />
    );
  }
  return (
    <span
      className={`inline-flex items-center rounded-full bg-primary-600 px-1.5 py-0.5 text-[10px] font-bold leading-none tracking-wider text-white ${className}`}
      aria-label="Nouveau"
    >
      NEW
    </span>
  );
}
